export const ECompanyInformationSection = {
  AGREEMENTS: "agreements",
} as const;

export type TCompanyInformationSection =
  (typeof ECompanyInformationSection)[keyof typeof ECompanyInformationSection];
